/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

var ToastThemeListEnum = /* @__PURE__ */function (ToastThemeListEnum2) {
  ToastThemeListEnum2["success"] = "success";
  ToastThemeListEnum2["warning"] = "warning";
  ToastThemeListEnum2["fail"] = "fail";
  ToastThemeListEnum2["loading"] = "loading";
  return ToastThemeListEnum2;
}(ToastThemeListEnum || {});
var IconType = /* @__PURE__ */function (IconType2) {
  IconType2["success"] = "check-circle";
  IconType2["warning"] = "error-circle";
  IconType2["fail"] = "close-circle";
  IconType2["loading"] = "loading";
  return IconType2;
}(IconType || {});
var defaultProps = {
  duration: 2e3,
  visible: true,
  content: "",
  icon: false
};

export { IconType, ToastThemeListEnum, defaultProps };
//# sourceMappingURL=constant.js.map
